import { CheckboxInput } from 'components/form/CheckboxInput';
import { useField } from 'formik';
import { ErrorM } from '../../form/ErrorM';
import BackButton from '../helpers/BackButton';
import { ReactComponent as LinkSvg } from 'assets/icon-link.svg';
import { ReactNode } from 'react';

export const FinalSteps = () => {
    return (
        <div>
            <BackButton />
            <h2>Final Steps</h2>
            <ButtonCheckboxInput
                name={fieldName('bTaxAcknowledgement')}
                label="Tax Acknowledgement"
                text="I confirm that the entity applying for the account is up to date and compliant with all applicable tax laws and regulations for which the entity would be responsible"
            />
            <ButtonCheckboxInput
                name={fieldName('bFatcaAcknowledgement')}
                label="FATCA Acknowledgement"
                text="I do confirm that I am in full compliance with the Foreign Account Tax Compliance Act (FATCA)"
            />
            <ButtonCheckboxInput
                name={fieldName('bConfirmTrueAndCorrect')}
                label="Information Supplied is True and Correct"
                text="I confirm that the information provided is true and correct. I will notify, in writing, any changes to the information provided. I am aware that all or part of the information provided in this questionnaire may be transferred to the tax administrator or to any other institution in accordance with international treaties or agreements, as well as the United States regarding automated exchange of information on financial accounts."
            />
            <ButtonCheckboxInput
                name={fieldName('bAcceptTerms')}
                label="Accept Services of Ibanera LLC"
                text="I agree to use the services of Ibanera LLC only for legitimate purposes. I acknowledge that false or incorrect information provided could require reports to regulators or law enforcement resulting in termionation of business relations"
            />
            <ButtonCheckboxInput
                name={fieldName('bEConsentDisclosure')}
                label="E-Consent Disclosure"
                text="I acknowledge and agree to the E-Consent Disclosure"
                link="https://ibanera.sharefile.com/d-s0568de3c6a7f41af82101dbe99a3bfb9"
            />
            <ButtonCheckboxInput
                name={fieldName('bDepositAccountAgreement')}
                label="Deposit Account Agreement"
                text="I acknowledge and agree to the Deposit Account Agreement"
            />
            <ButtonCheckboxInput
                name={fieldName('bUSAPatriotActNotice')}
                label="USA Patriot Act Notice"
                text="I have read and acknowledge the USA PATRIOT Act Notice displayed above."
                childComp={
                    <div className="crb-terms">
                        <hr />
                        <p>
                            <b>
                                Important Information About Procedures for Conducting Transactions
                            </b>
                        </p>
                        <p>
                            To help the government fight the funding of terrorism and money
                            laundering activities, federal law may require us to obtain, verify, and
                            record information that identifies each person who conducts a
                            transaction with the institution.
                        </p>
                        <p>
                            <b>What this means for you</b>
                        </p>
                        <p>
                            When you conduct a transaction with us, we may ask for your name,
                            address, date of birth, and other information that will allow us to
                            identify you, including your Social Security number. We may also ask to
                            see your driver’s license or other identifying documents.
                        </p>
                    </div>
                }
            />
        </div>
    );
};
const fieldName = (name: string) => `terms.${name}`;

export const ButtonCheckboxInput = ({
    name,
    label,
    text,
    showErrorMessage = false,
    link,
    childComp,
}: {
    name: string;
    label?: string;
    text: string;
    showErrorMessage?: boolean;
    link?: string;
    childComp?: ReactNode;
}) => {
    const [, { error, touched }] = useField(name);

    const hasError = !!(error && touched);
    return (
        <div className="FormBox">
            {label && (
                <div style={{ display: 'flex', gap: 5 }}>
                    <div className="FormLabel">
                        <label>{label}</label>
                    </div>
                    {link && (
                        <a href={link} target="_blank" style={{ marginTop: '-3px' }}>
                            <LinkSvg />
                        </a>
                    )}
                </div>
            )}
            <div className={`FormField ButtonCheckboxInput ${hasError ? 'Error' : ''}`}>
                <CheckboxInput name={name} label={text} />
                {childComp}
            </div>
            {showErrorMessage && <ErrorM name={name} />}
        </div>
    );
};
